import React from 'react';

const pages = {
  terms: {
    eyebrow: 'Terms of Service',
    title: 'Gone Fishin\' Terms of Service',
    intro: 'These Terms apply to your use of Gone Fishin\', a TikTok Mini Game developed, published, and operated by Neehaw LLC. By playing the game, you agree to these Terms.',
    sections: [
      ['Use of the game', 'Gone Fishin is provided for casual entertainment. You may use the game only for lawful, personal, and non-commercial purposes.'],
      ['No account required', 'Gone Fishin does not require you to create an account with us or submit personal information to play.'],
      ['User conduct', 'You agree not to misuse the game, interfere with its operation, attempt to reverse engineer it, exploit bugs, or use it in a way that violates applicable law or TikTok rules.'],
      ['Ownership', 'Gone Fishin, including its software, gameplay, text, visuals, branding, and related materials, is owned by Neehaw LLC or used by it with permission. These Terms do not transfer any ownership rights to you.'],
      ['Availability', 'The game is provided as is and as available. We may update, suspend, or stop offering the game at any time.'],
      ['Disclaimer', 'Gone Fishin is provided without warranties of any kind, whether express or implied. We do not promise that the game will always be available, uninterrupted, secure, or error-free.'],
      ['Limitation of liability', 'To the fullest extent allowed by law, Neehaw LLC will not be liable for indirect, incidental, special, consequential, or punitive damages arising from your use of Gone Fishin.'],
      ['TikTok platform', 'Your use of TikTok and TikTok Mini Apps may also be governed by TikTok terms, policies, and platform rules.'],
      ['Changes', 'We may update these Terms from time to time. Updates will be reflected by changing the effective date on this page.'],
      ['Contact', 'Contact Neehaw LLC at neehaw.service@gmail.com.'],
    ],
  },
  privacy: {
    eyebrow: 'Privacy Policy',
    title: 'Gone Fishin\' Privacy Policy',
    intro: 'This Privacy Policy explains how Neehaw LLC handles information in connection with Gone Fishin\', a TikTok Mini Game developed, published, and operated by Neehaw LLC.',
    sections: [
      ['Information we collect', 'Neehaw LLC does not directly request your name, email address, phone number, location, contacts, photos, or other identifying details through the game. We do not sell personal information collected through Gone Fishin.'],
      ['Gameplay data', 'The game stores gameplay information on your device, such as currency, upgrades, inventory, progress, and settings, so your progress can continue between sessions. You can clear this information by using the game\'s reset control or clearing site data in your browser or device.'],
      ['Analytics, advertising, and tracking', 'Gone Fishin does not currently use third-party analytics or advertising trackers operated by Neehaw LLC. The game may offer TikTok platform features, including login and advertising or purchase features, which TikTok may operate and measure under its own policies.'],
      ['TikTok platform', 'Because Gone Fishin runs as a TikTok Mini Game and uses the TikTok Mini Games SDK, TikTok may process device, account, authentication, advertising, purchase, and usage information under TikTok\'s own terms and privacy policy. Neehaw LLC does not control TikTok\'s independent platform data practices.'],
      ['Children', 'Gone Fishin is a casual game and Neehaw LLC does not knowingly request personal information directly from children. Eligibility to use TikTok and its Mini Games is governed by TikTok\'s applicable age requirements.'],
      ['Changes', 'If the game changes in a way that affects privacy, we will update this policy and revise the effective date.'],
      ['Contact', 'Contact Neehaw LLC at neehaw.service@gmail.com.'],
    ],
  },
  publisher: {
    eyebrow: 'Publisher Information',
    title: 'Gone Fishin\' Ownership & Publisher Information',
    intro: 'Gone Fishin is solely owned, developed, published, maintained, and operated by Neehaw LLC. Neehaw is the official company and publisher behind the game.',
    sections: [
      ['Legal owner and publisher', 'Neehaw LLC, an Iowa limited liability company.'],
      ['Game and domain', 'Game title: Gone Fishin. Official company website: https://neehaw.com/. The neehaw.com domain is owned and controlled by Neehaw LLC.'],
      ['Company relationship', 'Neehaw is the company and official publisher responsible for Gone Fishin.'],
      ['Authorized representative', 'Keegan Hutchins is the owner and authorized representative of Neehaw LLC.'],
      ['Contact', 'Ownership, publisher, legal, or support inquiries may be sent to neehaw.service@gmail.com.'],
    ],
  },
};

export default function GoneFishinLegal({ type }) {
  const page = pages[type] || pages.publisher;
  return (
    <main className="gone-fishin-legal">
      <div className="gone-fishin-legal-card">
        <p className="gone-fishin-legal-eyebrow">{page.eyebrow}</p>
        <h1>{page.title}</h1>
        <p className="gone-fishin-legal-date">Effective July 27, 2026</p>
        <p className="gone-fishin-legal-intro">{page.intro}</p>
        {page.sections.map(([heading, body]) => (
          <section key={heading}>
            <h2>{heading}</h2>
            <p>{body}</p>
          </section>
        ))}
      </div>
    </main>
  );
}
